<template>
  <!--专题添加  -->
  <div class="topicAdd">
    <el-card>
      <div class="add_box">
        <el-form :model="toEdDas" :rules="toEdRule" :label-position="labelPosition" ref="ruleForm">
          <el-row>
            <el-col :span="10">
              <el-form-item label="首页轮播" prop="isHomeRotation">
                <el-select placeholder="请选择" v-model="toEdDas.isHomeRotation" clearable>
                  <el-option
                    v-for="item in homeLun"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="是否上首页" prop="isRecommend">
                <el-select placeholder="请选择" v-model="toEdDas.isRecommend" clearable>
                  <el-option
                    v-for="item in homeIn"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="10">
              <el-form-item label="频道" prop="menuId">
                <el-select placeholder="请选择" v-model="toEdDas.menuId" clearable>
                  <el-option
                    v-for="item in menuDas"
                    :key="item.id"
                    :label="item.menuName"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="当前频道轮播" prop="isRotation">
                <el-select placeholder="请选择" v-model="toEdDas.isRotation" clearable>
                  <el-option
                    v-for="item in viewLun"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="专题名字" prop="specialName">
                <el-input placeholder="请输入内容" v-model="toEdDas.specialName" clearable />
              </el-form-item>
            </el-col>
            <!-- <el-col :span="10">
            <el-form-item label="审核" prop="examineStatus">
              <el-select placeholder="请选择" v-model="toEdDas.examineStatus" clearable>
                <el-option
                  v-for="item in examStatus"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
            </el-col>-->
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="权重" prop="sort">
                <el-input placeholder="请输入内容" v-model="toEdDas.sort" clearable />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <!-- <el-col :span="10">
            <el-form-item label="信息流展示" prop="showPosition">
                <el-select placeholder="请选择" v-model="toEdDas.showPosition" clearable>
                <el-option
                  v-for="item in messDas"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
            </el-col>-->
            <el-col :span="18">
              <el-form-item label="专题的说明" prop="specialExplain">
                <!-- <el-input placeholder="请输入内容" v-model="toEdDas.specialExplain" clearable /> -->
                <el-input
                  type="textarea"
                  :rows="10"
                  placeholder="请输入内容"
                  v-model="toEdDas.specialExplain"
                  clearable
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="app专题封面图(650*330)" prop="imgUrl">
                <el-upload
                  class="avatar-uploader"
                  action="https://jsonplaceholder.typicode.com/posts/"
                  :auto-upload="false"
                  :show-file-list="false"
                  :on-change="TopicUpt"
                  :on-success="TopicSuccess"
                  :before-upload="beforeUpload"
                >
                  <img v-if="toEdDas.imgUrl" :src="toEdDas.imgUrl" class="avatar" />
                 

                  <i
                    :class="loadUpt ? 'el-icon-loading' : 'el-icon-plus avatar-uploader-icon'"
                    style="marginTop:10px;font-size: 50px;"
                    v-else
                  ></i>
                </el-upload>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="pc专题封面图(1200*470)" prop="imgUrl">
                <el-upload
                  class="avatar-uploader"
                  action="https://jsonplaceholder.typicode.com/posts/"
                  :auto-upload="false"
                  :show-file-list="false"
                  :on-change="getTopicUptPC"
                  :on-success="TopicSuccess"
                  :before-upload="beforeUpload"
                >
                  <img v-if="toEdDas.pcImgUrl" :src="toEdDas.pcImgUrl" class="avatar" />
                 

                  <i
                    :class="loadUpt ? 'el-icon-loading' : 'el-icon-plus avatar-uploader-icon'"
                    style="marginTop:10px;font-size: 50px;"
                    v-else
                  ></i>
                </el-upload>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-button
              style="margin-left: 600px"
              type="primary"
              @click="submitEdit('ruleForm')"
              v-if="menuPerm('special:edit')"
            >保存</el-button>
          </el-row>
        </el-form>
      </div>
    </el-card>
  </div>
</template>
<script>
export default {
  data() {
    return {
      labelPosition: "top",
      loadUpt: false, //load-img
      menuDas: "", //频道的数据
      TopicUptImg: [], //app图片上传
      topicUptPc: [], //pc图片上传
      //添加的参数：
    

      toEdDas: "",
      toEdRule: {
        specialName: [
          { required: true, message: "内容不能为空", trigger: "blur" }
        ],
        specialExplain: [
          { required: true, message: "内容不能为空", trigger: "blur" }
        ],
        menuId: [
          { required: true, message: "内容不能为空", trigger: "change" }
        ],
        // showPosition: [{ required: true, message: "内容不能为空", trigger: "change" }],
        isRecommend: [
          { required: true, message: "内容不能为空", trigger: "change" }
        ],
        isRotation: [
          { required: true, message: "内容不能为空", trigger: "change" }
        ],
        isHomeRotation: [
          { required: true, message: "内容不能为空", trigger: "change" }
        ]
      },
      address: [
        {
          value: "1",
          label: "不显示"
        },
        {
          value: "2",
          label: "轮播"
        },
        {
          value: "3",
          label: "页面"
        }
      ],
      //   信息流展示：--下拉框
      messDas: [
        {
          value: "1",
          label: "是"
        },
        {
          value: "0",
          label: "不是"
        }
      ],

      //审核状态
      examStatus: [
        {
          value: "1",
          label: "是"
        },
        {
          value: "0",
          label: "不是"
        }
      ],

      //   是否上首页：--下拉框
      homeIn: [
        {
          value: "1",
          label: "是"
        },
        {
          value: "0",
          label: "不是"
        }
      ],

      //当前频道轮播:--下拉框
      viewLun: [
        {
          value: "1",
          label: "是"
        },
        {
          value: "0",
          label: "不是"
        }
      ],
      //首页轮播--下拉框：
      homeLun: [
        {
          value: "1",
          label: "是"
        },
        {
          value: "0",
          label: "不是"
        }
      ],
      backOpen: true
    };
  },
  methods: {
    //转base64
    getBase64(file) {
      return new Promise(function(resolve, reject) {
        let reader = new FileReader();
        let imgResult = "";
        reader.readAsDataURL(file.raw);
        reader.onload = function() {
          imgResult = reader.result;
        };
        reader.onerror = function(error) {
          reject(error);
        };
        reader.onloadend = function() {
          resolve(imgResult);
        };
      });
    },
    //上传图片限制
    beforeUpload(file, fileList) {
      return new Promise(resolve => {
        // 图片压缩
        let reader = new FileReader(),
          img = new Image();
        reader.readAsDataURL(file);
        reader.onload = function(e) {
          img.src = e.target.result;
        };

        img.onload = function() {
          let canvas = document.createElement("canvas");
          let context = canvas.getContext("2d");
          let width = "100";
          let height = "100";
          let originWidth = width;
          let originHeight = height;

          canvas.width = originWidth;
          canvas.height = originHeight;

          context.clearRect(0, 0, originWidth, originHeight);
          context.drawImage(img, 0, 0, originWidth, originHeight);

          canvas.toBlob(
            blob => {
              let imgFile = new File([blob], file.name, { type: file.type }); // 将blob对象转化为图片文件
              resolve(imgFile);
            },
            file.type,
            0.2
          ); // file压缩的图片类型
        };
      });
    },
    //图片上传：
    TopicUpt(file, fileList) {
      this.loadUpt = true;
      this.TopicUptImg = [];
      this.getBase64(file).then(resBase64 => {
        this.TopicUptImg.push(resBase64);
        if (this.TopicUptImg) {
          this.postAxios("/file/uploadBase64", {
            fileList: this.TopicUptImg
          }).then(res => {
            if (res.success == true) {
              this.$message.success("上传成功");
              this.toEdDas.imgUrl = res.content[0]; //接口url参数
              this.TopicUptImg = [];
            } else if (res.success == false) {
              this.$message.error(res.message);
            }

            if (!res.success && res.statusCode == "401") {
              this.$message.error(res.message);
              this.$router.push('/')
            }
          });
        }
      });
    },
    // pc上传
    getTopicUptPC(file, fileList) {
      this.loadUpt = true;
      this.topicUptPc = [];
      this.getBase64(file).then(resBase64 => {
        this.topicUptPc.push(resBase64);
        if (this.topicUptPc) {
          this.postAxios("/file/uploadBase64", {
            fileList: this.topicUptPc
          }).then(res => {
            if (res.success == true) {
              this.$message.success("上传成功");
              this.toEdDas.pcImgUrl = res.content[0]; //接口url参数
              this.topicUptPc = [];
            } else if (res.success == false) {
              this.$message.error(res.message);
            }

            if (!res.success && res.statusCode == "401") {
              this.$message.error(res.message);
              this.$router.push('/')
            }
          });
        }
      });
    },
    TopicSuccess(res, file) {},
    //新增专题：
    submitEdit(formName) {
      var id = this.Editdata.id;
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.postAxios("/special/update", {
            id: id,
            specialName: this.toEdDas.specialName, //专题名字
            imgUrl: this.toEdDas.imgUrl, //app专题封面图
            pcImgUrl: this.toEdDas.pcImgUrl, //pc专题封面图
            specialExplain: this.toEdDas.specialExplain, //专题的说明
            menuId: this.toEdDas.menuId, //展示的位置
            // showPosition:this.toEdDas.showPosition,//信息流展示
            isRecommend: this.toEdDas.isRecommend, //是否上首页
            isRotation: this.toEdDas.isRotation, //当前频道轮播
            isHomeRotation: this.toEdDas.isHomeRotation, //首页轮播
            sort:this.toEdDas.sort,
            // examineStatus: this.toEdDas.examineStatus //审核状态
          }).then(res => {
            if (res.success == true) {
              this.$message.success("修改成功！");
              this.$router.push({ path: "/topic" });
            } else if (res.success == false) {
              this.$message.error(res.message);
            } else if (
              !res.success && res.statusCode == "401"
            ) {
              this.$message.error(res.message);
              this.$router.push('/')
            }
          });
        } else {
          return false;
        }
      });
    },
    //频道下拉框数据：
    getPosition() {
      this.getAxios("/menu/list").then(res => {
        if (res.success == true) {
          this.menuDas = res.content;
        }
        if (res.message == false) {
          this.$message.error(res.message);
        }
        if (!res.success && res.statusCode == "401") {
          this.$message.error(res.message);
          this.$router.push('/')
        }
      });
    }
  },
  props: ["Editdata"],
  created() {
    this.getPosition(); //频道下拉框的数据
    this.toEdDas = this.Editdata;
  },
  watch:{
    Editdata(newVal,oldVal){
      this.toEdDas = this.Editdata;
    }
  }
};
</script>
<style scoped lang="less">
.topicAdd {
  width: 100%;
  height: 100%;
  .el-card {
    width: 95%;

    margin: 0 auto;
    margin-top: 15px;
  }

  .add_box {
    width: 95%;
    height: 100%;
    margin: 0 auto;
    /deep/ .el-upload {
      width: 200px;
      height: auto;
      display: inline-block;
      text-align: center;
      cursor: pointer;
      outline: 0;
      border: 1px solid #eee;
      img {
        width: 100%;
        height: auto;
      }
    }
    /deep/ .el-button--primary {
      color: #fff;
      background-color: #409eff;
      border-color: #409eff;
      width: 100px;
    }
  }
}
</style>